// src/pages/Reports/SuperDistributorReport.jsx
import React from 'react';
import BusinessReport from './BusinessReport';

const SuperDistributorReport = () => {
  return <BusinessReport userType="super-distributor" />;
};

export default SuperDistributorReport;